import { useFeatureFlagsContext } from "./featureFlagsContext";

export interface IFlagVariantConfig {
  // The posthog feature-flag key.
  id: string;
  // The variant value that counts as "active" (e.g. "test").
  variant: string;
  // Optional set of form names where the variant is force-disabled regardless
  // of cohort assignment (e.g. flows excluded from a given A/B test).
  excludeForms?: ReadonlySet<string>;
}

interface IUseFlagVariantOptions {
  formName?: string;
}

// Returns true when the current user is in `config.variant` for `config.id`
// AND the current form is not in `config.excludeForms`. Reads from
// `<FeatureFlagsProvider>` context so the value is correct from first render.
export const useFlagVariant = (
  config: IFlagVariantConfig,
  { formName }: IUseFlagVariantOptions = {},
): boolean => {
  const { flags } = useFeatureFlagsContext();

  if (config.excludeForms?.has(formName ?? "")) {
    return false;
  }

  return flags[config.id] === config.variant;
};
